import { KFLButton, KFLIcon } from '@kamstrup/kamstrup-frontend-library';
import React from 'react';
import { MessageType } from '../../../core/localization';
import useLocale from '../../../hooks/useLocale';
import { UserInfo } from '../../../models';
import { Transfer, TransferType } from '../../../modules/dialogs/transfer';
import useTx from '../../../modules/dialogs/transfer/useTx';
import Ellipsis from '../../shared/ellipsis';
import SVGIcon, { SVGIcons } from '../../shared/svgIcon';
import * as m from '../../../modules/dialogs/transfer/messages';
import ENV from '../../../variables';
import { Environments } from '../../../variables/const';
import './transferSummary.scss';

const userInfoSummary = (ui: UserInfo) =>
  `Organisation: ${ui.customer.customerName} (${ui.customer.customerId})
      User: ${ui.email} (${ui.userId})`;

const IconSummary = (transfer: Transfer) => {
  const tooltip = `Transfer Info:
          Transfer Id: ${transfer.id}
          Type: ${transfer.type}
          Status: ${transfer.status}
          Num devices: ${transfer.devices.length}
          From: ${userInfoSummary(transfer.sender)}
          To: ${userInfoSummary(transfer.receiver)}`;
  return (
    <span title={tooltip} style={{ display: 'inline-block' }}>
      <KFLIcon name="Info" size="xs" />
    </span>
  );
};

export const TxInfoIcon = (tx: Transfer) =>
  ENV !== Environments.LOCAL && ENV !== Environments.NIGHTLY ? (
    <></>
  ) : (
    IconSummary(tx)
  );

const sendIcon = <SVGIcon name={SVGIcons.TxSend} width="100%" height="100%" />;

const requestIcon = (
  <SVGIcon name={SVGIcons.TxRequest} width="100%" height="100%" />
);

export const roundOkIcon = (
  <SVGIcon name={SVGIcons.RoundTick} width="100%" height="100%" />
);

export const roundFailIcon = (
  <SVGIcon name={SVGIcons.RoundDismiss} width="100%" height="100%" />
);

type Props = {
  transfer: Transfer;
  title?: MessageType;
  icon?: JSX.Element;
};

const TransferSummary: React.FC<Props> = ({ transfer, title, icon }) => {
  const { showTxDevices } = useTx();
  const { translate } = useLocale();
  const isSend = transfer.type === TransferType.SEND;
  const txIcon = icon ? icon : isSend ? sendIcon : requestIcon;
  const header = title ? title : isSend ? m.msgSumamryHeaderSend : m.msgSumamryHeaderReq;
  const msgNumKeys = translate(m.msgSumamryKeys(transfer.devices.length));
  const msgTo = translate(m.msgSumamryTo);
  const extraInfo = isSend ? (
    <div>
      <div className="txs_extra_to">
        <div>{msgTo}</div>
        <span className="bold">
          <Ellipsis>{transfer.receiver.email}</Ellipsis>
        </span>
      </div>
      <div className="txs_extra_to_customer">
        <Ellipsis>{transfer.receiver.customer.customerName}</Ellipsis>
      </div>
    </div>
  ) : (
    <></>
  );
  return (
    <div className="transfer_summary">
      <div>
        <div className="tsx_icon">
          <div>{txIcon}</div>
        </div>
      </div>

      <p className="txs_header">
        {translate(header)} {TxInfoIcon(transfer)}
      </p>
      <div className="txs_devices">
        <KFLButton
          variant="borderless"
          onClick={() => showTxDevices(transfer.id, transfer.devices)}
        >
          {msgNumKeys}
        </KFLButton>
      </div>
      <div className="txs_extra">{extraInfo}</div>
    </div>
  );
};

export default TransferSummary;
